import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bda8bf9a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "email-preview-modal__top" };
const _hoisted_2 = { class: "email-preview-modal__top-inner" };
const _hoisted_3 = { class: "email-preview-modal__title-row" };
const _hoisted_4 = ["aria-label"];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    class: "email-preview-modal__close-icon",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    focusable: "false"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M4 4L20 20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1",
        "stroke-linecap": "square"
    }),
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M20 4L4 20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "1",
        "stroke-linecap": "square"
    })
], -1));
const _hoisted_6 = [
    _hoisted_5
];
const _hoisted_7 = {
    key: 0,
    class: "email-preview-modal__meta"
};
const _hoisted_8 = { class: "email-preview-modal__meta-info" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_10 = { class: "email-preview-modal__meta-info" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_12 = { class: "email-preview-modal__meta-info" };
const _hoisted_13 = { class: "email-preview-modal__body" };
const _hoisted_14 = { class: "email-preview-modal__body-content" };
const _hoisted_15 = ["srcdoc"];
const _hoisted_16 = {
    key: 1,
    class: "email-body-text"
};
const _hoisted_17 = {
    key: 2,
    class: "email-body-empty"
};
const _hoisted_18 = { class: "preview-footer" };
import { computed } from 'vue';
import { sanitizeHtml } from '../utils/sanitizeHtml';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TemplatePreviewDialog',
    props: {
        modelValue: { type: Boolean },
        template: {},
        status: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit }) {
        const props = __props;
        const model = computed({
            get: () => props.modelValue,
            set: (v) => emit('update:modelValue', v),
        });
        const templateObj = computed(() => {
            if (!props.template)
                return {};
            if (typeof props.template === 'string')
                return { texto: props.template };
            return props.template;
        });
        const sanitizedHtml = computed(() => {
            return templateObj.value.html ? sanitizeHtml(templateObj.value.html) : '';
        });
        const iframeSrcdoc = computed(() => {
            if (!sanitizedHtml.value)
                return '';
            return `<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <style>
    html, body { margin: 0; padding: 0; background: #ffffff; overflow-x: hidden; }
    img, video { max-width: 100%; height: auto; }
    table { max-width: 100%; box-sizing: border-box; }
  </style>
</head>
<body>${sanitizedHtml.value}</body>
</html>`;
        });
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: model.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((model).value = $event)),
                class: "email-preview-modal",
                id: "email-preview-modal",
                width: "800px",
                "append-to-body": true,
                "destroy-on-close": true,
                "show-close": false
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('breadcrumb.email.campaigns.preview.title')), 1),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "email-preview-modal__close",
                                    "aria-label": _ctx.$t('close'),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (model.value = false))
                                }, _hoisted_6, 8, _hoisted_4)
                            ]),
                            (_ctx.template)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('breadcrumb.email.campaigns.preview.subject-label')) + ":", 1),
                                        _hoisted_9,
                                        _createElementVNode("span", null, _toDisplayString(templateObj.value.assunto || _ctx.$t('breadcrumb.email.campaigns.preview.empty-subject')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('breadcrumb.email.campaigns.preview.preheader-label')) + ":", 1),
                                        _hoisted_11,
                                        _createElementVNode("span", null, _toDisplayString(templateObj.value.precabecalho || _ctx.$t('breadcrumb.email.campaigns.preview.empty-preheader')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('breadcrumb.email.campaigns.preview.body-label')) + ":", 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[1] || (_cache[1] = ($event) => (model.value = false))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
                            ]),
                            _: 1
                        })
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            (sanitizedHtml.value)
                                ? (_openBlock(), _createElementBlock("iframe", {
                                    key: 0,
                                    class: "email-preview-modal__iframe",
                                    srcdoc: iframeSrcdoc.value,
                                    sandbox: "",
                                    "aria-label": "Email preview"
                                }, null, 8, _hoisted_15))
                                : (templateObj.value.texto)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(templateObj.value.texto), 1))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t('breadcrumb.email.campaigns.preview.empty-body')), 1))
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
